
























































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Color, TorikeshiFlg, SumiFlg } from '@/constants/constants';
import { getDefaultPagerInfo } from '@/utils/utils';
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_110_SeikyuList',
  components: {},
  props: {
    search: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    Color,
    TorikeshiFlg,
    SumiFlg,
    headers: [
      {
        text: '発行日',
        value: 'seikyushoHakoYmd',
        width: 100,
        sortable: true,
      },
      {
        text: '事業所',
        value: 'seikyuJigyoshoMei',
        width: 100,
        sortable: true,
      },
      {
        text: '請求書№',
        value: 'seikyushoNo',
        width: 100,
        sortable: true,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '請求先',
        value: 'seikyusakiMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
      },
      {
        text: '締日',
        value: 'seikyuShimeYmd',
        width: 100,
        sortable: true,
      },
      {
        text: '御請求金額',
        value: 'konkaiSeikyuKingaku',
        width: 120,
        sortable: true,
        class: 'text-end',
        cellClass: 'text-end',
      },
      { text: '請求書', value: 'action', sortable: false, width: 80 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
  }),
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 340;
    },
  },
  methods: {
    customSearch(_value: any, search: string | null, item: any) {
      const filterValues = [
        item['seikyushoHakoYmd'],
        item['seikyushoNo'],
        item['seikyusakiMei'],
        item['seikyuShimeYmd'],
        item['konkaiSeikyuKingaku'],
      ];

      return filterValues.some(
        (v: any) =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search ? search.toLowerCase() : '')
      );
    },
    downloadUpd(item: any){
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].seikyuJikkoYmd === item.seikyuJikkoYmd &&
            this.items[i].seikyuKanriNo === item.seikyuKanriNo &&
            this.items[i].seikyuJigyoshoCd === item.seikyuJigyoshoCd &&
            this.items[i].seikyusakiCd === item.seikyusakiCd &&
            this.items[i].seikyushoNo === item.seikyushoNo &&
            this.items[i].seikyuTorikeshiFlg === item.seikyuTorikeshiFlg
           ){
            this.items[i].downloadFlg = SumiFlg.SUMI;
            return;
        }
      }
    }
  },
  mounted() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
